import { connect }         from 'react-redux';
import { logout }          from '../../../user-dux';
import { fetchCatalogUrl } from '../../../catalog-dux';
import { getMediaLabel }   from '../../routes/home';

import Header from './header.jsx';

export default connect(
    // mapStateToProps
    state => {
        const mediaLabels = state.clientData.clientBranding.mediaLabels;
        const user = state.userData;
        const clientLogo = state.clientData.clientBranding.clientLogo;
        const mediaLabel = getMediaLabel( mediaLabels, user.locale, state.clientData.locale );
        return {
            user,
            clientLogo,
            mediaLabel
        };
    },
    // mapDispatchToProps
    {
        fetchCatalogUrl,
        logout
    }
)( Header );
